import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {InterLinkComponent} from './inter-link.component';
import {TagTextModule} from '../tag-text/tag-text.module';
import { TranslateModule } from '@ngx-translate/core';


@NgModule({
    declarations: [
        InterLinkComponent
    ],
    exports: [
        InterLinkComponent
    ],
    imports: [
        CommonModule,
        TagTextModule,
        TranslateModule
    ]
})
export class InterLinkModule {
}
